export default "__VITE_ASSET__6e94fb80__"